<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6633_34761)">
<rect opacity="0.01" width="24" height="24" fill="#444646"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5081 5.55806C14.7521 5.31398 15.1479 5.31398 15.3919 5.55806C15.6254 5.79152 15.6356 6.16374 15.4224 6.40927L15.3919 6.44194L9.88375 11.95L15.3919 17.4581C15.6254 17.6915 15.6356 18.0637 15.4224 18.3093L15.3919 18.3419C15.1585 18.5754 14.7863 18.5856 14.5407 18.3724L14.5081 18.3419L8.55806 12.3919C8.32459 12.1585 8.31444 11.7863 8.52761 11.5407L8.55806 11.5081L14.5081 5.55806Z" fill="#A09EA3"/>
</g>
<defs>
<clipPath id="clip0_6633_34761">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
